import type { PropertyId } from '@previo/codebooks'
import { HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'
import type {
  SuggestDetailResponse,
  SuggestDetailsResponse,
  SuggestResponse,
} from '~/http/backoffice/properties/types'

export class PropertiesAPI extends Http {
  suggest = (search: string): Promise<SuggestResponse> => {
    return this.callAuthAPI<null, SuggestResponse>(HttpMethod.GET, {
      path: APIPaths.PROPERTIES_SUGGEST,
      query: { keyword: search },
    })
  }

  suggestDetail = (id: number): Promise<SuggestDetailResponse> => {
    return this.callAuthAPI<null, SuggestDetailResponse>(HttpMethod.GET, {
      path: APIPaths.PROPERTY_SUGGEST_DETAIL,
      params: { propertyId: id },
    })
  }

  suggestDetails = (ids: PropertyId[]): Promise<SuggestDetailsResponse> => {
    return this.callAuthAPI<null, SuggestDetailsResponse>(HttpMethod.GET, {
      path: APIPaths.PROPERTIES_SUGGEST,
      query: { ids: ids },
    })
  }
}
